// @ts-nocheck

/**
 * * `REVENUECAT` - RevenueCat (Mobile)
 * `STRIPE` - Stripe (Web)
 * `PAYPAL` - PayPal (Web)
 * `ADMIN` - Admin Grant
 */
export type PaymentSourceEnum =
  typeof PaymentSourceEnum[keyof typeof PaymentSourceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSourceEnum = {
  REVENUECAT: "REVENUECAT",
  STRIPE: "STRIPE",
  PAYPAL: "PAYPAL",
  ADMIN: "ADMIN",
} as const;
